'use strict';

exports.__esModule = true;
exports.default = undefined;

var _UploadFeedback = require('./UploadFeedback');

var _UploadFeedback2 = _interopRequireDefault(_UploadFeedback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _UploadFeedback2.default;
module.exports = exports['default'];